import React from 'react';
import { get, first } from 'lodash';
import { connect } from 'react-redux';
import { useModelInfo } from '../../common/ModelInfoContext';
import { TranslateHTML } from 'core/translate';
import {
  TRIMS,
  PACKAGES,
  OPTIONS,
  MODELS,
  PACKAGES_AND_OPTIONS,
} from '../../common/steps';
import LegalDisclosure from '../legalDisclosure/LegalDisclosure';

const StepHeader = ({
  matrix,
  selectedBodyType,
  appResources,
  step,
  isBodyTypeRevealed,
  isSelectionRevealed,
  selectedTrim,
}) => {
  const {
    enableConfigStep,
    enableModelsStep,
    hasTransactionId,
  } = useModelInfo();

  const stepData = first(
    get(appResources, 'processSteps', []).filter((x) => x.key === step)
  );

  const getTrimHeader = () => {
    if (enableModelsStep) {
      return get(stepData, 'header', '');
    }

    if (hasTransactionId) {
      return get(stepData, 'tidHeader', '');
    }

    const selectedBodyTypeFromMatrix = first(
      get(matrix, 'bodyTypes', []).filter((x) => selectedBodyType.id === x.id)
    );

    return get(selectedBodyTypeFromMatrix, 'header');
  };

  const header = step === TRIMS ? getTrimHeader() : get(stepData, 'header', '');
  const subheader = get(stepData, 'tidSubHeader', '');

  const showLegalDisclosure =
    step === PACKAGES || step === OPTIONS || step === PACKAGES_AND_OPTIONS;

  const getModelsHeader = () => {
    return hasTransactionId
      ? get(stepData, 'tidHeader', '')
      : get(stepData, 'header', '');
  };

  return (
    <>
      {step === MODELS ? (
        <div className="step-header">
          <div>{getModelsHeader()}</div>
          <div className="step-header__subheader">{subheader}</div>
        </div>
      ) : (
        <>
          {enableConfigStep &&
          step === TRIMS &&
          (isBodyTypeRevealed || isSelectionRevealed) ? (
            <div className="step-header">
              <div className="package-header">{header}</div>
              <TranslateHTML
                className="step-header__subheader"
                value="trims.step.subheader.v3"
                bodyType={selectedBodyType.formattedConfig}
              />
            </div>
          ) : (
            <div className="step-header">
              <div className="package-header">{header}</div>
              {showLegalDisclosure ? <LegalDisclosure showAsStatic /> : null}
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    config,
    appResources,
    isSelectionRevealed,
    isBodyTypeRevealed,
    matrix,
  } = state;

  const { bodyType: selectedBodyType } = config;
  const selectedTrim = config?.selections?.trimName;

  return {
    selectedBodyType,
    selectedTrim,
    appResources,
    isBodyTypeRevealed,
    isSelectionRevealed,
    matrix,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(StepHeader);
